import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ServicepageService {
    constructor(private http: HttpClient) { }

    getservicesService() {
        return this.http.get<any[]>(`${environment.apiUrl}services`);
    }    	    
}
